/**
 * SessionActions — End session / Save buttons at the bottom of the feedback panel.
 *
 * Provides the two primary session actions:
 *  - "End Session" — discards without saving (with confirmation)
 *  - "Prepare Feedback" — aggregates comments via LLM before submission
 */

interface SessionActionsProps {
  readonly commentCount: number;
  readonly isSaving: boolean;
  readonly isAggregating: boolean;
  readonly onSave: () => void;
  readonly onEndSession: () => void;
}

export function SessionActions({
  commentCount,
  isSaving,
  isAggregating,
  onSave,
  onEndSession,
}: SessionActionsProps) {
  const busy = isSaving || isAggregating;
  const saveLabel = isAggregating
    ? "Analyzing…"
    : isSaving
      ? "Saving…"
      : "Prepare Feedback";

  return (
    <div className="fb-session-actions">
      <button
        type="button"
        className="fb-action-btn fb-action-btn--end"
        onClick={onEndSession}
        disabled={busy}
      >
        End Session
      </button>
      <button
        type="button"
        className="fb-action-btn fb-action-btn--save"
        onClick={onSave}
        disabled={commentCount === 0 || busy}
        title={
          commentCount === 0
            ? "Record at least one comment first"
            : "Analyze feedback and prepare submission"
        }
      >
        {saveLabel}
      </button>
    </div>
  );
}
